import Model from "./Model";

export default class ServiceTool extends Model {
  static type = "serviceTools";

  serviceId!: string;
  toolId!: string;
}
